import type { ObjectProps } from './object-props';

export type CornerStyle = 'rect' | 'circle';

export interface LockInteractionProps {
  lockMovementX: boolean;
  lockMovementY: boolean;
  lockRotation: boolean;
  lockScalingX: boolean;
  lockScalingY: boolean;
  lockSkewingX: boolean;
  lockSkewingY: boolean;
  lockScalingFlip: boolean;
}

export interface ControlStyleProps {
  cornerSize: number;
  touchCornerSize: number;
  transparentCorners: boolean;
  cornerColor: string;
  cornerStrokeColor: string;
  cornerStyle: CornerStyle;
  cornerDashArray: number[] | null;
  padding: number;
  hasControls: boolean;
}

export interface BorderStyleProps {
  borderColor: string;
  borderDashArray: number[] | null;
  borderOpacityWhenMoving: number;
  borderScaleFactor: number;
  hasBorders: boolean;
  selectionBackgroundColor: string;
}

export interface InteractionBehaviorProps {
  selectable: boolean;
  evented: boolean;
  perPixelTargetFind: boolean;
  activeOn: 'down' | 'up';
  hoverCursor: CSSStyleDeclaration['cursor'] | null;
  moveCursor: CSSStyleDeclaration['cursor'] | null;
  snapAngle?: number;
  snapThreshold?: number;
  noScaleCache: boolean;
}

export interface InteractiveObjectProps
  extends ObjectProps,
    LockInteractionProps,
    ControlStyleProps,
    BorderStyleProps,
    InteractionBehaviorProps {}

export const lockInteractionDefaults: LockInteractionProps = {
  lockMovementX: false,
  lockMovementY: false,
  lockRotation: false,
  lockScalingX: false,
  lockScalingY: false,
  lockSkewingX: false,
  lockSkewingY: false,
  lockScalingFlip: false,
};

export const controlStyleDefaults: ControlStyleProps = {
  cornerSize: 13,
  touchCornerSize: 24,
  transparentCorners: true,
  cornerColor: 'rgb(178,204,255)',
  cornerStrokeColor: '',
  cornerStyle: 'rect',
  cornerDashArray: null,
  padding: 0,
  hasControls: true,
};

export const borderStyleDefaults: BorderStyleProps = {
  borderColor: 'rgb(178,204,255)',
  borderDashArray: null,
  borderOpacityWhenMoving: 0.4,
  borderScaleFactor: 1,
  hasBorders: true,
  selectionBackgroundColor: '',
};

export const interactionBehaviorDefaults: InteractionBehaviorProps = {
  selectable: true,
  evented: true,
  perPixelTargetFind: false,
  activeOn: 'down',
  hoverCursor: null,
  moveCursor: null,
  snapAngle: undefined,
  snapThreshold: undefined,
  noScaleCache: true,
};

export const interactiveObjectDefaults: Pick<
  InteractiveObjectProps,
  keyof LockInteractionProps | keyof ControlStyleProps | keyof BorderStyleProps | keyof InteractionBehaviorProps
> = {
  ...lockInteractionDefaults,
  ...controlStyleDefaults,
  ...borderStyleDefaults,
  ...interactionBehaviorDefaults,
};
